import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import checklistData from '../content/checklist.json';

const ChecklistModal = ({ checklistDialogOpen, toggleChecklistDialog }) => {
  return (
    <Dialog open={checklistDialogOpen} scroll="paper">
      <DialogTitle>Contract Request Checklist</DialogTitle>
      <DialogContent dividers>
        <List
          sx={{
            listStyleType: 'disc',
            pl: 2,
            '& .MuiListItem-root': {
              display: 'list-item',
            },
          }}
        >
          {checklistData.map((checklistItem, index) => (
            <ListItem
              sx={{
                padding: '.2rem',
              }}
              key={index}
            >
              <ListItemText>{checklistItem.text}</ListItemText>
            </ListItem>
          ))}
        </List>
        <DialogActions>
          <Button onClick={toggleChecklistDialog} variant="primary">
            Close
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ChecklistModal;
